import Layout from "../../Classes/Layout";
import { layoutCategoryModalSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    open: false,
    layoutToAdd: new Layout()
}

export default function layoutCategoryModalSlice(state = initialState, action) {
    switch (action.type) {
        case layoutCategoryModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case layoutCategoryModalSliceDispatch.setLayoutToAdd: {
            return {
                ...state,
                layoutToAdd: action.payload
            }
        }
        default:
            return state
    }
}
